import React from 'react';
import GolfSearchResultsTemplete from '../components/template/golfSearchResultsTemplete';
import store from '..';
import common from "../resources/js/common/common"
import { golfReservationList } from '../const';
class GolfPlanList extends React.Component{
    constructor(props) {
        super(props);
        this.state = { 
            savedSearchCriteriaPopup: false,
            PlayDatePopup: false, 
            startTimePopup: false,
            areaSelectionPopup: false,  
            confirmPopup: false,
            completePopup: false,
            popupDataList: [],
            golfReservationPopup : false,
        };
    };
    

    render(){
        // 検索条件保存モーダル
        const onClickOpenSavedSearchCriteriaWindow = () => this.setState({ savedSearchCriteriaPopup: !this.state.savedSearchCriteriaPopup });
        // カレンダーモーダル
        const onClickOpenSelectDateWindow = () => this.setState({ PlayDatePopup: !this.state.PlayDatePopup });
        // 開始時間モダール
        const onClickOpenStartTimeWindow = () => this.setState({ startTimePopup: !this.state.startTimePopup });
        // エリア・施設モーダル
        const onClickOpenSelectAreaWindow = () => this.setState({ areaSelectionPopup: !this.state.areaSelectionPopup });
        // 確認ダイアログ
        const onClickOpenConfirm = () => this.setState({ confirmPopup: !this.state.confirmPopup });
        // 完了ダイアログ
        const onClickOpenComplete = () => this.setState({ completePopup: !this.state.completePopup });

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.Data,
                    }
                );
            }
        }

        return(
            <GolfSearchResultsTemplete 
            state={this.state} 
            onClickOpenSavedSearchCriteriaWindow={onClickOpenSavedSearchCriteriaWindow}
            onClickOpenSelectDateWindow={onClickOpenSelectDateWindow} 
            onClickOpenStartTimeWindow={onClickOpenStartTimeWindow} 
            onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
            onClickOpenConfirm={onClickOpenConfirm}
            onClickOpenComplete={onClickOpenComplete} 
            onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
            onClickClosePopupWindow={onClickClosePopupWindow}/>
        )
    }
}
export default GolfPlanList;